// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ZfXw","content":"styles_content__1dlNa"};